const shippopUrl =
  'https://apps.apple.com/us/app/shippop-application/id1547240927?itsct=apps_box&amp;itscg=30200'
const shippopProUrl =
  'https://apps.apple.com/us/app/shippop/id1512333682?itsct=apps_box&amp;itscg=30200'

const AppStoreBadge = ({
  width = 200,
  shippopType = 'shippop',
  style,
  ...otherProps
}) => {
  return (
    <a
      href={shippopType === 'shippopPro' ? shippopProUrl : shippopUrl}
      target="_blank"
      style={{ width: width, padding: 10, ...style }}
      {...otherProps}
    >
      <img
        src="/static/img/shippop-app/app_store_badge.svg"
        alt="Download on the App Store"
        style={{ width: width - 20 }}
      />
    </a>
  )
}

export default AppStoreBadge
